import { useNavigate } from "react-router-dom";
import InteractiveMap from "./figma-map/InteractiveMap";

/**
 * MiniatureTransparencyMap - Mini preview of the interactive transparency map for homepage
 *
 * Features:
 * - Shows the same beautiful Figma map as /transparency-map page
 * - Clicking anywhere navigates to /transparency-map
 * - Same bouncy hover animations (stiffness: 400, damping: 10)
 * - Simple wrapper that prevents modal, just links to full page
 */
export default function MiniatureTransparencyMap() {
  const navigate = useNavigate();

  const handleAnyClick = () => {
    navigate("/transparency-map");
  };

  return (
    <div
      className="relative w-full max-w-[852px] mx-auto cursor-pointer group"
      onClick={handleAnyClick}
    >
      {/* Use the same InteractiveMap component from the transparency map page */}
      <div className="pointer-events-none">
        <InteractiveMap onStateClick={handleAnyClick} />
      </div>

      {/* Hover overlay - "Click to Explore" prompt */}
      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300 flex items-center justify-center pointer-events-none rounded-lg">
        <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="bg-brand-azure text-white px-6 py-3 rounded-lg font-agency font-bold text-lg shadow-lg">
            Click to Explore Interactive Map
          </div>
        </div>
      </div>
    </div>
  );
}
